










































































































import { Component } from 'vue-property-decorator'
import BaseDialog from '@/utils/dialog-control'
import $Api from '@api'
import { of } from 'rxjs'

@Component
export default class BankDialog extends BaseDialog {
    form = {
        digisignRegisterStatus: '',
        digisignRegisterMsg: '',
        digisignActiveStatus: '',
        rdlStatus: '',
        mobile: '',
        email: '',
        userName: '',
        noktp: '',
        permanentAddress: '',
        birthday: '',
        sex: '',
        nationality: '',
        province: '',
        city: '',
        street: '',
        community: '',
        postcode: '',
        education: '',
        religion: '',
        jobCode: '',
        address: '',
        industry: '',
        rdlAccount: ''
    }
    rules = {}

    get title() {
        return this.$t('common.btn.edit')
    }

    update() {
        return of(0)
    }

    create() {
        return of(0)
    }

    onOpen() {
    }

    onClose() {
    }
}
